import { defineRouting } from "next-intl/routing";

import { countriesType } from "../lib/types";

import { pathnames } from "./pathnames";

export { pathnames };

export const siteLocales = process.env.SITE_LOCALES?.split(
  ",",
) as countriesType[];
export const allLocales = process.env.LOCALES?.split(",") as countriesType[];

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: siteLocales,

  // Used when no locale matches
  defaultLocale: process.env.DEFAULT_LOCALE as countriesType,
  localePrefix: "as-needed",
  localeDetection: false,
  // Disable the locale cookie to avoid security concerns (HttpOnly/Secure flags)
  // Since localeDetection is false and locale is determined from URL, cookie is not needed
  localeCookie: false,
  pathnames,
});

// The navigation wrappers (Link etc.) live in ./navigation - this module is
// imported by proxy.ts (middleware), and createNavigation pulls in the
// request config, whose next/root-params import is app-directory-only.
